/* Baby Fair - cart engine: ajax add/change/remove, slide-in drawer,
   animated free shipping meter, and a shared click-outside dismisser
   for every overlay in the theme. */
(function () {
  'use strict';

  /* the drawer and the cart page both include this file; run it once */
  if (window.__bfCartLoaded) return;
  window.__bfCartLoaded = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var lastDone = null;
  var qtyTimer = null;

  /* ---------------- helpers ---------------- */
  function sectionIds() {
    var els = document.querySelectorAll('[data-bf-cart-section]');
    var ids = [];
    for (var i = 0; i < els.length; i++) {
      var id = els[i].getAttribute('data-bf-cart-section');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    }
    return ids;
  }

  function readPct() {
    var bar = document.querySelector('[data-bf-ship]');
    if (!bar) return null;
    return parseFloat(bar.getAttribute('data-bf-ship-pct')) || 0;
  }

  function setBusy(on) {
    busy = on;
    var d = document.querySelector('.bf-drawer');
    if (d) d.classList.toggle('is-busy', on);
  }

  /* ---------------- free shipping meter ---------------- */
  function paintBars(fromPct) {
    var bars = document.querySelectorAll('[data-bf-ship]');
    if (!bars.length) return;
    var pct = readPct();
    var done = !!document.querySelector('[data-bf-ship][data-bf-ship-done]');

    Array.prototype.forEach.call(bars, function (bar) {
      var fill = bar.querySelector('.bf-ship__fill');
      var truck = bar.querySelector('.bf-ship__truck');
      if (!fill) return;
      if (fromPct !== null && fromPct !== undefined) {
        fill.style.transition = 'none';
        fill.style.width = fromPct + '%';
        if (truck) { truck.style.transition = 'none'; truck.style.left = fromPct + '%'; }
        void fill.offsetWidth;
        fill.style.transition = '';
        if (truck) truck.style.transition = '';
      }
      requestAnimationFrame(function () {
        fill.style.width = pct + '%';
        if (truck) truck.style.left = pct + '%';
      });
    });

    if (done && lastDone === false) {
      Array.prototype.forEach.call(bars, celebrate);
    }
    lastDone = done;
  }

  function celebrate(bar) {
    bar.classList.remove('is-cheer');
    void bar.offsetWidth;
    bar.classList.add('is-cheer');
    var host = bar.querySelector('[data-bf-confetti]');
    if (!host) return;
    host.innerHTML = '';
    var colours = ['#e5327f', '#f5a623', '#2f8a4c', '#4aa3df', '#c9236b'];
    for (var i = 0; i < 16; i++) {
      var p = document.createElement('i');
      p.style.left = (6 + Math.random() * 88) + '%';
      p.style.background = colours[i % colours.length];
      p.style.setProperty('--bf-dx', (Math.random() * 60 - 30).toFixed(1) + 'px');
      p.style.setProperty('--bf-rot', Math.round(Math.random() * 540 - 270) + 'deg');
      p.style.animationDelay = (Math.random() * 0.18).toFixed(2) + 's';
      host.appendChild(p);
    }
    setTimeout(function () { if (host) host.innerHTML = ''; }, 1600);
  }

  /* ---------------- section swapping ---------------- */
  function swap(sections, fromPct) {
    if (sections) {
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var target = document.querySelector('[data-bf-cart-section="' + id + '"]');
        if (!target) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-bf-cart-section="' + id + '"]');
        if (fresh) target.innerHTML = fresh.innerHTML;
      });
    }
    syncCount();
    paintBars(fromPct);
  }

  function syncCount() {
    var src = document.querySelector('[data-bf-cart-itemcount]');
    if (!src) return;
    var n = src.textContent.trim();
    var nodes = document.querySelectorAll('[data-bf-cart-count], .bf-icon-btn__count');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = n;
  }

  /* ---------------- cart api ---------------- */
  function post(path, body) {
    var ids = sectionIds();
    if (ids.length) {
      body.sections = ids;
      body.sections_url = window.location.pathname + window.location.search;
    }
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }

  function add(id, qty, showDrawer) {
    if (busy) return Promise.resolve();
    setBusy(true);
    var from = readPct();
    return post('cart/add.js', { items: [{ id: id, quantity: qty || 1 }] })
      .then(function (res) {
        swap(res.sections, from);
        if (showDrawer !== false) open();
        setBusy(false);
        return res;
      })
      .catch(function (err) {
        setBusy(false);
        if (err && err.description) window.alert(err.description);
        else window.location.href = ROOT + 'cart';
      });
  }

  function change(key, quantity, row) {
    if (busy) return Promise.resolve();
    setBusy(true);
    if (row && quantity === 0) row.classList.add('is-going');
    var from = readPct();
    return post('cart/change.js', { id: key, quantity: quantity })
      .then(function (res) { swap(res.sections, from); setBusy(false); return res; })
      .catch(function () { setBusy(false); window.location.reload(); });
  }

  function refresh() {
    var ids = sectionIds();
    if (!ids.length) return;
    var from = readPct();
    fetch(ROOT + '?sections=' + encodeURIComponent(ids.join(',')), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { swap(j, from); })
      .catch(function () { });
  }

  /* ---------------- drawer ---------------- */
  function open() {
    if (!document.querySelector('.bf-drawer')) { window.location.href = ROOT + 'cart'; return; }
    document.body.classList.add('bf-cart-open');
    document.body.classList.add('bf-drawer-open');
  }
  function close() {
    document.body.classList.remove('bf-cart-open');
    document.body.classList.remove('bf-drawer-open');
  }

  /* ---------------- events ---------------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-bf-cart-close]')) { e.preventDefault(); close(); return; }

    var opener = e.target.closest('[data-bf-cart-open]');
    if (opener) { e.preventDefault(); open(); return; }

    var link = e.target.closest('a[href]');
    if (link && !e.metaKey && !e.ctrlKey && !link.closest('.bf-drawer')) {
      var href = link.getAttribute('href') || '';
      if (/(^|\/)cart\/?(\?|$)/.test(href) && document.querySelector('.bf-drawer')) {
        e.preventDefault(); open(); return;
      }
    }

    var minus = e.target.closest('[data-bf-line-minus]');
    var plus = e.target.closest('[data-bf-line-plus]');
    if (minus || plus) {
      var wrap = (minus || plus).closest('.bf-cqty');
      var input = wrap && wrap.querySelector('[data-bf-line-qty]');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 1) + (plus ? 1 : -1);
      if (next < 0) next = 0;
      input.value = next;
      change(input.getAttribute('data-bf-key'), next, (minus || plus).closest('.bf-ditem, .bf-cart__row'));
      return;
    }

    var rm = e.target.closest('[data-bf-line-remove]');
    if (rm) {
      e.preventDefault();
      change(rm.getAttribute('data-bf-key'), 0, rm.closest('.bf-ditem, .bf-cart__row'));
      return;
    }

    var quickAdd = e.target.closest('[data-bf-cart-add]');
    if (quickAdd) {
      e.preventDefault();
      add(quickAdd.getAttribute('data-bf-cart-add'), 1, true);
      return;
    }

    var coupon = e.target.closest('[data-bf-coupon-apply]');
    if (coupon) {
      e.preventDefault();
      var field = document.querySelector('[data-bf-coupon]');
      var code = field && field.value.trim();
      if (!code) { if (field) field.focus(); return; }
      window.location.href = ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(ROOT + 'cart');
      return;
    }
  });

  /* product-page add-to-cart form -> drawer instead of a page load */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var action = f.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (!document.querySelector('.bf-drawer')) return;

    var idEl = f.querySelector('[name="id"]');
    if (!idEl || !idEl.value) return;
    e.preventDefault();

    var qtyEl = f.querySelector('[name="quantity"]');
    var n = qtyEl ? parseInt(qtyEl.value, 10) : 1;
    var btn = f.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = '<span>Adding...</span>'; }

    add(idEl.value, isNaN(n) || n < 1 ? 1 : n, true).then(function () {
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
    });
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-bf-line-qty]');
    if (!input) return;
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 0) v = 0;
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function () {
      change(input.getAttribute('data-bf-key'), v, input.closest('.bf-ditem, .bf-cart__row'));
    }, 250);
  });

  window.BFCart = { add: add, change: change, open: open, close: close, refresh: refresh };

  function init() {
    lastDone = !!document.querySelector('[data-bf-ship][data-bf-ship-done]');
    paintBars(0);
    syncCount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* =======================================================================
     Shared dismisser: tapping or clicking anywhere outside an open overlay
     closes it. Bound in the CAPTURE phase so the very click that opens an
     overlay cannot immediately close it again.
     ======================================================================= */
  var OVERLAYS = [
    {
      isOpen: function () { return document.body.classList.contains('bf-cart-open'); },
      panel: '.bf-drawer__panel',
      close: close
    },
    {
      isOpen: function () { var m = document.querySelector('.bf-qv'); return !!m && m.classList.contains('is-open'); },
      panel: '.bf-qv__dialog',
      close: function () { var b = document.querySelector('.bf-qv [data-qv-close]'); if (b) b.click(); }
    },
    {
      isOpen: function () { return !!document.querySelector('.bf-facets.is-open'); },
      panel: '.bf-facets.is-open',
      close: function () {
        var f = document.querySelector('.bf-facets.is-open');
        if (f) f.classList.remove('is-open');
        var s = document.querySelector('.bf-facets__scrim.is-open');
        if (s) s.classList.remove('is-open');
        document.body.classList.remove('bf-drawer-open');
      }
    },
    {
      isOpen: function () { var m = document.querySelector('.bf-mmenu'); return !!m && !m.hidden; },
      panel: '.bf-mmenu__panel',
      close: function () {
        var m = document.querySelector('.bf-mmenu');
        if (m) { m.hidden = true; document.body.style.overflow = ''; }
      }
    }
  ];

  function dismissOutside(e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    for (var i = 0; i < OVERLAYS.length; i++) {
      var o = OVERLAYS[i];
      if (!o.isOpen()) continue;
      var panel = document.querySelector(o.panel);
      if (panel && (panel === t || panel.contains(t))) continue;
      o.close();
    }
  }

  if (window.PointerEvent) {
    document.addEventListener('pointerdown', dismissOutside, true);
  } else {
    document.addEventListener('mousedown', dismissOutside, true);
    document.addEventListener('touchstart', dismissOutside, true);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    for (var i = 0; i < OVERLAYS.length; i++) {
      if (OVERLAYS[i].isOpen()) OVERLAYS[i].close();
    }
  });
})();
